import { Mapping } from 'api/MappingsAPI';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export type UserMappingsContextState = {
  isErrorUserMappings: boolean;
  isLoadingUserMappings: boolean;
  refetchUserMappings: () => void;
  userMappings: Mapping[];
};

export const initialUserMappingsState: UserMappingsContextState = {
  isErrorUserMappings: false,
  isLoadingUserMappings: false,
  refetchUserMappings: noop,
  userMappings: [],
};

export const UserMappingsContext = createContext(initialUserMappingsState);

export const useUserMappingsContext = () => useContext(UserMappingsContext);
